import axios from "axios"
import { API_URL } from "../configs/app"

export const loginAdmin = async (data) => {
    let response = await axios.post(`${API_URL}/auth/admin/login`, data)
    return response.data
}